import { ChangeDetectionStrategy, Component } from '@angular/core'

@Component({
  selector: 'app-action-card',
  templateUrl: './action-card.component.html',
  styleUrls: ['./action-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ActionCardComponent {}
